<template>
  <div class="hello">
    <b-container>
      <b-container>
        <b-card no-body size="sm" class="my-2 border-dark pt-2" v-for="rank in parentDeptRanks" :key="rank.index">
      <b-row>
        <b-col>
          <h4 v-show="!checkShowStatus(rank)" >{{ rank.deptrankName }}</h4>
          <b-form-input v-if="checkShowStatus(rank)" type="text" v-model="editValue" />
        </b-col> 
        <b-col cols="2">
          <em v-if="!checkShowStatus(rank)">(Sort: {{ rank.deptrankSortOrder }})</em>
          <b-form-input v-if="checkShowStatus(rank)" type="number" v-model="sortValue" />
        </b-col> 
        <b-col cols="3">
          <b-btn size="sm" variant="warning" v-show="!checkShowStatus(rank)" @click="showEditBox(rank)" >Edit</b-btn>
          <b-btn @click="showEditBox(rank)" v-show="checkShowStatus(rank)" size="sm" variant="warning">Cancel</b-btn>
           <b-btn v-show="checkShowStatus(rank)" size="sm" variant="info" :class="{disabled: rank.deptrankName == editValue && rank.deptrankSortOrder == sortValue}" @click="updateDeptRank(rank)">Update</b-btn>
          <b-btn size="sm" variant="danger" v-if="userData.role == 'admin'" :class="{disabled: filterSubDeptRanks(rank).length > 0}"  @click="deleteSub(rank)">Delete</b-btn>
        </b-col>
      </b-row>

      </b-card>
      <b-card class="bg-primary">
      <b-card class="border-primary" header-slot="header">
        <h5><em>Add New Deptartment Rank</em></h5>
        <b-container>
        <b-row>
          <b-col>
        <b-form-input :placeholder="'New DeptRank Parent Category Name'" v-model="newSubCatName" />
          </b-col>
          <b-col cols="*">
        <b-btn variant="primary" @click="addNew()">Add New</b-btn>
          </b-col>
          </b-row>
          </b-container>
      </b-card>
      </b-card>
      </b-container>
    </b-container>
  </div>


</template>

<script>
import { mapState } from 'vuex'
import { bus } from '../../../main'
import moment from 'moment'
import axios from 'axios'
export default {
  props: ['taxData'],
  name: 'hello',
  components: { 


  },
  data () {
    return {
    newSubCatName: '',
    editId: '',
    editData: false,
    editValue: '',
    sortValue: '',

    }
  },
  created(){
    
  },
  computed: {
      ...mapState([
        'userData',

        'getSessionData'
      ]),
      parentDeptRanks(){
        return _.orderBy(this.taxData, ['deptrankSortOrder'], ['asc'])
      },
      testUserRights(){
        if(this.userData.role == 'adminchief'
          || this.userData.role == 'admin'){
            return false
          } else {
            return true
          }
      },

      /*

      How to filter against two arrays

      docArray(){
        var loaded = [... new Set(this.ranksApi.map(p => p.field_rank_id))]
        var bulk = [... new Set(this.docArrayPre.map(p => p.field_rank_id))]
        var test = this.docArrayPre
        console.log(loaded)
        console.log(bulk)
        for(var i = 0; i < loaded.length; i++){
          var index = bulk.indexOf(loaded[i])
          if(index > -1){
          test.splice(index, 1)}
        }
        return test

      } */
  },
  watch: {

},
  methods: {
    showEditBox(rank){
      if(this.editId == ''){
        this.editId = rank.id
        this.editValue = rank.deptrankName
        this.sortValue = rank.deptrankSortOrder
      } else if (rank.id != this.editId){
        this.editId = rank.id
         this.editValue = rank.deptrankName
          this.sortValue = rank.deptrankSortOrder
      } else {
        this.editId = ''
         this.editValue = ''
         this.sortValue = ''
      }
      
    },
    checkShowStatus(rank){
        if(rank.id != this.editId){
          return false
        } else {
          return true
        }
      },
    filterSubDeptRanks(data){
      return this.taxData.filter( p => {
        if(p.deptrankParent != '' && p.deptrankParent != undefined && p.deptrankParent != null){
          return p.deptrankParent == data.deptrankName
        }
      })
    },
    addNew(){
     var headers = { headers: { 'content-type': 'application/json', 'Authorization': this.getSessionData } }
     var payload = { taxonomy: 'deptrank', headers: headers, expire: true}
    axios({
      method: 'post',
      url: '/api/v1/taxonomy/deptrank/',
      data: {
        'deptrankName': this.newSubCatName,
        'deptrankSortOrder': 10,
      },
        headers: payload.headers.headers,
      }).then(response => {
      this.$store.dispatch('LOAD_TAXONOMY_DATA_EXP', payload)
          this.newSubCatName = ''
  
      })
    
    },
    deleteSub(rank){
      var result = confirm('Are You Sure You Want to Delete ' + rank.deptrankName + ' ?')
      if (result) {
     var headers = { headers: { 'content-type': 'application/json', 'Authorization': this.getSessionData } }
     var payload = { taxonomy: 'deptrank', headers: headers, expire: true}
    axios({
      method: 'delete',
      url: '/api/v1/taxonomy/deptrank/' + rank.id,
      headers: payload.headers.headers,
      }).then(response => {
      this.$store.dispatch('LOAD_TAXONOMY_DATA_EXP', payload)
  
      })
    } else {}
    },
    updateDeptRank(rank){
     var headers = { headers: { 'content-type': 'application/json', 'Authorization': this.getSessionData } }
     var payload = { taxonomy: 'deptrank', headers: headers, expire: true}
      axios({
        method: 'patch',
        url: '/api/v1/taxonomy/deptrank/' + rank.id,
        data: {
          'deptrankName': this.editValue,
          'deptrankSortOrder': this.sortValue,
        },
        headers: payload.headers.headers,
      }).then(response => {
        if(parent == ''){
          for(var i = 0; i < childDeptRanks.length;){
            var count = 1
            var counter = childDeptRanks.length
            axios({
              method: 'patch',
              url: '/api/v1/taxonomy/deptrank/' + childDeptRanks[i].id,
              data: {
                'deptrankName': childDeptRanks[i].deptrankName,
                'deptrankParent': this.editValue
              },
               headers: payload.headers.headers,
             }).then(response => {
               count++
               if(count == counter)
              this.$nextTick(function(){
              this.$store.dispatch('LOAD_TAXONOMY_DATA_EXP', payload)
               this.editValue = ''
               this.editId = ''
                })
               })
               i++
       
          }    


        } else {
        console.log(response.data)
        this.$store.dispatch('LOAD_TAXONOMY_DATA_EXP', payload)
        this.editValue = ''
        this.editId = ''
        }
      })
    },
  
  
 },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.table th {
  text-align: center !important;
}
</style>
<style slot-scoped>
h1, h2 {
  font-weight: normal;
}
</style>